export const MONTHS = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
export const MONTHS_LONG = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

const abs = Math.abs;
const n0 = (v) => Math.round(abs(v)).toLocaleString("en-US");
export const money = (v) => `${v < 0 ? "−" : ""}MX$${n0(v || 0)}`;
export const signed = (v) => `${v > 0 ? "+" : v < 0 ? "−" : ""}MX$${n0(v || 0)}`;
export const pct = (v, d = 1) => (v == null ? "—" : `${(v * 100).toFixed(d)}%`);
export const dpct = (v, d = 1) => (v == null ? "—" : `${v > 0 ? "+" : v < 0 ? "−" : ""}${(abs(v) * 100).toFixed(d)}%`);
export const dpts = (v) => (v == null ? "—" : `${v > 0 ? "+" : v < 0 ? "−" : ""}${(abs(v) * 100).toFixed(1)} pts`);
export const k = (v) => { const a = abs(v || 0), s = v < 0 ? "−" : ""; return a >= 1e6 ? `${s}${(a / 1e6).toFixed(2)}M` : a >= 1e3 ? `${s}${Math.round(a / 1e3)}k` : `${s}${Math.round(a)}`; };
export const sk = (v) => `${v > 0 ? "+" : ""}${k(v)}`;

// Tope "bonito" para el eje Y (p. ej. 36,998 → 40,000).
export const niceMax = (v) => { if (!v || v <= 0) return 1; const step = 10 ** Math.floor(Math.log10(v)); return Math.ceil((v * 1.08) / (step / 2)) * (step / 2); };
export const ticksTo = (top) => [0, top / 4, top / 2, (top * 3) / 4, top];
export const toneOf = (v) => (v == null || v === 0 ? "text-zinc-400" : v > 0 ? "text-[#00873D]" : "text-[#E0000F]");

export const COLORS = { in: "#00873D", out: "#E0000F", gas: "#F59E0B", sin: "#c9c5bd", bal: "#002FA7" };

// Solo meses con movimiento, con neto, sin registrar, razones y cambio del saldo.
export function monthlyRows(months) {
  const known = (months || []).filter((m) => m.known);
  let acum = 0;
  return known.map((m, i) => {
    const prev = i > 0 ? known[i - 1].balance_end_mxn : null;
    const prevVentas = i > 0 ? known[i - 1].sales_mxn || 0 : null;
    const saldo = m.balance_end_mxn;
    acum += m.sales_mxn || 0;
    return {
      month: m.month, mes: MONTHS[m.month - 1], mesLargo: MONTHS_LONG[m.month - 1],
      entro: m.inflow_mxn, salio: m.outflow_mxn, gastos: m.expenses_mxn, saldo,
      neto: m.inflow_mxn - m.outflow_mxn,
      sin: m.outflow_mxn - m.expenses_mxn,
      pctRegistrado: m.outflow_mxn ? m.expenses_mxn / m.outflow_mxn : null,
      ratio: m.inflow_mxn ? m.expenses_mxn / m.inflow_mxn : null,
      crec: saldo != null && prev ? saldo / prev - 1 : null,
      ventas: m.sales_mxn || 0, notas: m.sales_count || 0, ventasAcum: acum,
      ventasCrec: prevVentas ? (m.sales_mxn || 0) / prevVentas - 1 : null,
      byCategory: m.by_category || {},
    };
  });
}

export function yearTotals(rows) {
  if (!rows.length) return null;
  const sum = (key) => rows.reduce((a, r) => a + (r[key] || 0), 0);
  const last = rows[rows.length - 1], prev = rows.length > 1 ? rows[rows.length - 2] : null;
  const ch = (key) => (prev && prev[key] ? last[key] / prev[key] - 1 : null);
  const entro = sum("entro"), salio = sum("salio"), gastos = sum("gastos");
  return {
    entro, salio, gastos, neto: entro - salio, sin: salio - gastos,
    ventas: sum("ventas"), notas: sum("notas"),
    pctRegistrado: salio ? gastos / salio : null, ratio: entro ? gastos / entro : null,
    saldo: last.saldo, mes: last.mes, mesLargo: last.mesLargo, mesAnterior: prev?.mes || null,
    ultimoEntro: last.entro, ultimoSalio: last.salio, ultimoNeto: last.neto, ultimoRatio: last.ratio,
    entroDelta: ch("entro"), salioDelta: ch("salio"), saldoDelta: ch("saldo"),
    ratioDeltaPts: prev && last.ratio != null && prev.ratio != null ? last.ratio - prev.ratio : null,
    mesesNegativos: rows.filter((r) => r.neto < 0).length,
  };
}

// Ranking de categorías; las pequeñas se agrupan en "Otras (N categorías)".
export function mixRows(items, max = 7) {
  const sorted = [...items].sort((a, b) => b.value - a.value);
  const total = sorted.reduce((s, c) => s + c.value, 0) || 1;
  const top = sorted.slice(0, max), rest = sorted.slice(max);
  const out = top.map((c) => ({ ...c, pct: c.value / total, otro: false }));
  if (rest.length) out.push({ id: "otras", name: `Otras (${rest.length} categorías)`, value: rest.reduce((s, c) => s + c.value, 0), pct: rest.reduce((s, c) => s + c.value, 0) / total, otro: true });
  return out;
}
